export default "__VITE_ASSET__CCuh8DQG__"